/**
 * Stats Model for V2 Services
 */

export interface DashboardStats {
  totalUsers: number;
  totalBookings: number;
  totalRevenue: number;
  activeBookings: number;
  completedBookings: number;
  cancelledBookings: number;
  averageRating: number;
  totalRobots: number;
  activeRobots: number;
  lastUpdated?: Date;
}

export interface GlobalStats {
  totalUsers: number;
  totalBookings: number;
  totalHappyClients: number;
  totalSquareFootCleaned: number;
  totalApartmentsServiced: number;
  averageCleaningTime: number;
  totalRevenue: number;
  lastUpdated?: Date;
}

export interface RevenueStats {
  daily: Record<string, number>;
  weekly: Record<string, number>;
  monthly: Record<string, number>;
  yearly: Record<string, number>;
  total: number;
  lastUpdated?: Date;
}

export class Stats {
  public dashboard: DashboardStats;
  public global: GlobalStats;
  public revenue: RevenueStats;

  constructor() {
    this.dashboard = {
      totalUsers: 0,
      totalBookings: 0,
      totalRevenue: 0,
      activeBookings: 0,
      completedBookings: 0,
      cancelledBookings: 0,
      averageRating: 0,
      totalRobots: 0,
      activeRobots: 0
    };

    this.global = {
      totalUsers: 0,
      totalBookings: 0,
      totalHappyClients: 0,
      totalSquareFootCleaned: 0,
      totalApartmentsServiced: 0,
      averageCleaningTime: 0,
      totalRevenue: 0
    };

    this.revenue = {
      daily: {},
      weekly: {},
      monthly: {},
      yearly: {},
      total: 0
    };
  }

  public static fromFirestore(data: any): Stats {
    const stats = new Stats();

    if (data.dashboard) {
      stats.dashboard = {
        ...stats.dashboard,
        ...data.dashboard,
        lastUpdated: data.dashboard.lastUpdated?.toDate?.() || data.dashboard.lastUpdated
      };
    }

    if (data.global) {
      stats.global = {
        ...stats.global,
        ...data.global,
        lastUpdated: data.global.lastUpdated?.toDate?.() || data.global.lastUpdated
      };
    }

    if (data.revenue) {
      stats.revenue = {
        ...stats.revenue,
        ...data.revenue,
        lastUpdated: data.revenue.lastUpdated?.toDate?.() || data.revenue.lastUpdated
      };
    }

    return stats;
  }

  public incrementStat(category: 'dashboard' | 'global', field: string, value = 1): void {
    if (category === 'dashboard' && field in this.dashboard) {
      (this.dashboard as any)[field] += value;
    } else if (category === 'global' && field in this.global) {
      (this.global as any)[field] += value;
    }
  }

  public updateRevenue(period: 'daily' | 'weekly' | 'monthly' | 'yearly', key: string, value: number): void {
    this.revenue[period][key] = (this.revenue[period][key] || 0) + value;
    this.revenue.total += value;
  }
}